// Logo du portail servi depuis public/ (PNG 128 px de haut, cache navigateur)
// au lieu de 363 Ko de base64 embarqués dans le bundle principal et rendus
// en 32-48 px. Même export, mêmes appelants (Sidebar, Dashboard, activation).
export const LOGO_SRC = '/logo-portail.png';
